<template>
  <div>
    <el-form
      :model="ruleForm"
      :rules="rules"
      ref="ruleForm"
      class="fromData"
      label-position="right"
      label-width="100px"
    >
      <el-form-item label="组织名称" prop="name" style="widht:50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="组织类型" prop="name" style="widht:50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="用户名" prop="name" style="width:49%">
        <el-select v-model="value" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="真实姓名" prop="name" style="widht:50%">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="登录密码" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="确认密码" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="密码提示" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="手机" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="固定电话" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="短信接收人" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
      <el-form-item label="系统使用者" prop="name">
        <el-input v-model="ruleForm.name"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer addcentent">
      <el-button @click="dialogVisible">取 消</el-button>
      <el-button type="primary" @click="resetForm('ruleForm')">确 定</el-button>
    </span>
  </div>
</template>
<script>
export default {
  props: {
    diohide: {
      type: Function,
      default: Function
    }
  },
  data() {
    return {
      options:[
        {
          value:'1',
          lable:'admin'
        }
      ],
      ruleForm: {
        name: ""
      },
      rules: {
        name: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          { min: 3, max: 5, message: "长度在 3 到 5 个字符", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    // 确定
    resetForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          alert("submit!");
          this.diohide(); //关闭他弹框
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    dialogVisible() {
      this.diohide();
    }
  }
};
</script>
<style>
.el-form-item {
  margin-bottom: 10px;
}
.addcentent {
  display: flex;
  justify-content: center;
}
.fromData {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
</style>